"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NounsDAOLogicV1__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "NewAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldImplementation",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newImplementation",
                type: "address",
            },
        ],
        name: "NewImplementation",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldPendingAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "NewPendingAdmin",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "oldVetoer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "NewVetoer",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalCanceled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                indexed: false,
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "ProposalCreatedWithRequirements",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalExecuted",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
        ],
        name: "ProposalQueued",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldProposalThresholdBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "ProposalThresholdBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
        ],
        name: "ProposalVetoed",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldQuorumVotesBPS",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "QuorumVotesBPSSet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "voter",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "votes",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "VoteCast",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingDelay",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "VotingDelaySet",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "oldVotingPeriod",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "VotingPeriodSet",
        type: "event",
    },
    {
        inputs: [],
        name: "BALLOT_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "DOMAIN_TYPEHASH",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MAX_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_PROPOSAL_THRESHOLD_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_QUORUM_VOTES_BPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_DELAY",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "MIN_VOTING_PERIOD",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "_acceptAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "_burnVetoPower",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newPendingAdmin",
                type: "address",
            },
        ],
        name: "_setPendingAdmin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newProposalThresholdBPS",
                type: "uint256",
            },
        ],
        name: "_setProposalThresholdBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newQuorumVotesBPS",
                type: "uint256",
            },
        ],
        name: "_setQuorumVotesBPS",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newVetoer",
                type: "address",
            },
        ],
        name: "_setVetoer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingDelay",
                type: "uint256",
            },
        ],
        name: "_setVotingDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newVotingPeriod",
                type: "uint256",
            },
        ],
        name: "_setVotingPeriod",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "admin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "cancel",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
        ],
        name: "castVote",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "uint8",
                name: "v",
                type: "uint8",
            },
            {
                internalType: "bytes32",
                name: "r",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "s",
                type: "bytes32",
            },
        ],
        name: "castVoteBySig",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "support",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "reason",
                type: "string",
            },
        ],
        name: "castVoteWithReason",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "execute",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "getActions",
        outputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "voter",
                type: "address",
            },
        ],
        name: "getReceipt",
        outputs: [
            {
                components: [
                    {
                        internalType: "bool",
                        name: "hasVoted",
                        type: "bool",
                    },
                    {
                        internalType: "uint8",
                        name: "support",
                        type: "uint8",
                    },
                    {
                        internalType: "uint96",
                        name: "votes",
                        type: "uint96",
                    },
                ],
                internalType: "struct NounsDAOStorageV1.Receipt",
                name: "",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "implementation",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "timelock_",
                type: "address",
            },
            {
                internalType: "address",
                name: "nouns_",
                type: "address",
            },
            {
                internalType: "address",
                name: "vetoer_",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "votingPeriod_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "votingDelay_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "proposalThresholdBPS_",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotesBPS_",
                type: "uint256",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "latestProposalIds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "name",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "nouns",
        outputs: [
            {
                internalType: "contract NounsTokenLike",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pendingAdmin",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalMaxOperations",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThreshold",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proposalThresholdBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "proposals",
        outputs: [
            {
                internalType: "uint256",
                name: "id",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "proposer",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "proposalThreshold",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "quorumVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "eta",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "startBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "endBlock",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "forVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "againstVotes",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "abstainVotes",
                type: "uint256",
            },
            {
                internalType: "bool",
                name: "canceled",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "vetoed",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "executed",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address[]",
                name: "targets",
                type: "address[]",
            },
            {
                internalType: "uint256[]",
                name: "values",
                type: "uint256[]",
            },
            {
                internalType: "string[]",
                name: "signatures",
                type: "string[]",
            },
            {
                internalType: "bytes[]",
                name: "calldatas",
                type: "bytes[]",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
        ],
        name: "propose",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "queue",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotes",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "quorumVotesBPS",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "state",
        outputs: [
            {
                internalType: "enum NounsDAOStorageV1.ProposalState",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "timelock",
        outputs: [
            {
                internalType: "contract INounsDAOExecutor",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "proposalId",
                type: "uint256",
            },
        ],
        name: "veto",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "vetoer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingDelay",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "votingPeriod",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "0x608060405234801561001057600080fd5b5061478b806100206000396000f3fe608060405234801561001057600080fd5b50600436106103155760003560e01c80636f3eff28116101a7578063c82fbd08116100ee578063deaaa7cc11610097578063e9c714f211610071578063e9c714f2146107f2578063f851a440146107fa578063fe0d94c11461080d57600080fd5b8063deaaa7cc14610704578063e23a9a521461072b578063e48083fe146106a757600080fd5b8063da35c664116100c8578063da35c664146106d5578063da95691a146106de578063ddf0b009146106f157600080fd5b8063c82fbd08146106a7578063d33219b4146106af578063d8bff440146106c257600080fd5b8063a64e024a11610150578063b71d1a0c1161012a578063b71d1a0c14610683578063bb67758214610696578063bf7a29631461069f57600080fd5b8063a64e024a14610668578063b112626314610672578063b58131b01461067b57600080fd5b806383cce0e11161018157806383cce0e11461063957806396300b7d1461064257806397d048e51461065557600080fd5b80636f3eff281461060b5780637b3c71d31461061e5780637bdbe4d01461063157600080fd5b80632230e1551161026b5780633932abb11161021457806340e58ee5116101ee57806340e58ee5146105d257806356781388146105e55780635c60da1b146105f857600080fd5b80633932abb1146105965780633bccf4fd1461059f5780633e4f49e6146105b257600080fd5b80632b4656c8116102455780632b4656c81461054d5780632de45f1814610560578063328dd9821461057357600080fd5b80632230e1551461051257806324bc1a641461051a578063267822471461052257600080fd5b806317977c61116102cd5780631e7b5d3a116102a75780631e7b5d3a146104d957806320606b70146104e2578063215809ca1461050957600080fd5b806317977c61146104935780631d28dec7146104b35780631dfb1b5a146104c657600080fd5b806306fdde03116102fe57806306fdde031461042c5780630ea2d98c1461047557806314a67ea41461048a57600080fd5b8063013cf08b1461031a57806302a251a314610415575b600080fd5b6103a061032836600461394b565b600b602081905260009182526040909120805460018201546002830154600384015460048501546009860154600a87015497870154600c880154600d890154600e9099015497996001600160a01b039097169895979496939592949192909160ff80821691610100810482169162010000909104168d565b604080519d8e526001600160a01b03909c1660208e01529a8c019990995260608b019790975260808a019590955260a089019390935260c088019190915260e08701526101008601526101208501521515610140840152151561016083015215156101808201526101a0015b60405180910390f35b61041e60055481565b60405190815260200161040c565b6104686040518060400160405280600981526020017f4e6f756e732044414f000000000000000000000000000000000000000000000081525081565b60405161040c91906139c0565b61048861048336600461394b565b610820565b005b61041e60065481565b61041e6104a13660046139ef565b600c6020526000908152604090205481565b6104886104c136600461394b565b610972565b6104886104d436600461394b565b610c61565b61041e6103e881565b61041e7f8cad95687ba82c2ce50e74f7b754645e5117c3a5bec8151c0726d5857980a86681565b61041e61168081565b61041e60c881565b61041e610da4565b600154610535906001600160a01b031681565b6040516001600160a01b03909116815260200161040c565b61048861055b366004613a0a565b610e3b565b600a54610535906001600160a01b031681565b61058661058136600461394b565b61137c565b60405161040c9493929190613b3b565b61041e60045481565b6104886105ad366004613ba4565b61160d565b6105c56105c036600461394b565b6118be565b60405161040c9190613c21565b6104886105e036600461394b565b611a9f565b6104886105f3366004613c62565b611e00565b600254610535906001600160a01b031681565b61048861061936600461394b565b611e70565b61048861062c366004613c8e565b611fb3565b61041e600a81565b61041e60075481565b6104886106503660046139ef565b612003565b61048861066336600461394b565b612104565b61041e62013b0081565b61041e619d8081565b61041e612247565b6104886106913660046139ef565b6122a2565b61041e6107d081565b610488612394565b61041e600181565b600954610535906001600160a01b031681565b600354610535906001600160a01b031681565b61041e60085481565b61041e6106ec366004613ffc565b612420565b6104886106ff36600461394b565b612b43565b61041e7f150214d74d59b7d1e90c73fc22ef3d991dd0a76b046543d4d80ab92d2a50328f81565b6107bd6107393660046140ce565b6040805160608101825260008082526020820181905291810191909152506000918252600b602090815260408084206001600160a01b03939093168452600f9092018152918190208151606081018352905460ff8082161515835261010082041693820193909352620100009092046bffffffffffffffffffffffff169082015290565b6040805182511515815260208084015160ff1690820152918101516bffffffffffffffffffffffff169082015260600161040c565b610488612e80565b600054610535906001600160a01b031681565b61048861081b36600461394b565b612fd1565b6000546001600160a01b031633146108a55760405162461bcd60e51b815260206004820152602660248201527f4e6f756e7344414f3a3a5f736574566f74696e67506572696f643a2061646d6960448201527f6e206f6e6c79000000000000000000000000000000000000000000000000000060648201526084015b60405180910390fd5b61168081101580156108ba575062013b008111155b61092c5760405162461bcd60e51b815260206004820152603160248201527f4e6f756e7344414f3a3a5f736574566f74696e67506572696f643a20696e766160448201527f6c696420766f74696e6720706572696f64000000000000000000000000000000606482015260840161089c565b600580549082905560408051828152602081018490527f7e3f7f0708a84de9203036abaa450dccc85ad5ff52f78c170f3edb55cf5e882891015b60405180910390a15050565b6003546001600160a01b03166109f05760405162461bcd60e51b815260206004820152602160248201527f4e6f756e7344414f3a3a7665746f3a207665746f20706f776572206275726e6560448201527f6400000000000000000000000000000000000000000000000000000000000000606482015260840161089c565b6003546001600160a01b03163314610a4a5760405162461bcd60e51b815260206004820152601b60248201527f4e6f756e7344414f3a3a7665746f3a206f6e6c79207665746f65720000000000604482015260640161089c565b6007610a55826118be565b6008811115610a6657610a66613bf2565b03610ad95760405162461bcd60e51b815260206004820152602d60248201527f4e6f756e7344414f3a3a7665746f3a2063616e6e6f74207665746f206578656360448201527f757465642070726f706f73616c00000000000000000000000000000000000000606482015260840161089c565b6000818152600b60205260408120600e810180547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00ff16610100179055905b6005820154811015610c30576009546005830180546001600160a01b039092169163591fcdfe919084908110610b4f57610b4f6140f1565b6000918252602090912001546006850180546001600160a01b039092169185908110610b7d57610b7d6140f1565b9060005260206000200154856007018581548110610b9d57610b9d6140f1565b90600052602060002001866008018681548110610bbc57610bbc6140f1565b9060005260206000200187600401546040518663ffffffff1660e01b8152600401610beb959493929190614208565b600060405180830381600087803b158015610c0557600080fd5b505af1158015610c19573d6000803e3d6000fd5b505050508080610c2890614284565b915050610b17565b506040518281527fde0cea2a3a0097cc3d981d40c375407760e85bc9c5e69aea449ac3885f8615c690602001610966565b6000546001600160a01b03163314610ce15760405162461bcd60e51b815260206004820152602560248201527f4e6f756e7344414f3a3a5f736574566f74696e6744656c61793a2061646d696e60448201527f206f6e6c79000000000000000000000000000000000000000000000000000000606482015260840161089c565b60018110158015610cf45750619d808111155b610d665760405162461bcd60e51b815260206004820152602f60248201527f4e6f756e7344414f3a3a5f736574566f74696e6744656c61793a20696e76616c60448201527f696420766f74696e672064656c61790000000000000000000000000000000000606482015260840161089c565b600480549082905560408051828152602081018490527fc565b045403dc03c2eea82b81a0465edad9e2e7fc4d97e11421c209da93d7a939101610966565b6000610e36600754600a60009054906101000a90046001600160a01b03166001600160a01b03166318160ddd6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610dff573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610e2391906142bc565b6bffffffffffffffffffffffff16613200565b905090565b6009546001600160a01b031615610eba5760405162461bcd60e51b815260206004820152602e60248201527f4e6f756e7344414f3a3a696e697469616c697a653a2063616e206f6e6c79206960448201527f6e697469616c697a65206f6e6365000000000000000000000000000000000000606482015260840161089c565b6000546001600160a01b03163314610f145760405162461bcd60e51b815260206004820181905260248201527f4e6f756e7344414f3a3a696e697469616c697a653a2061646d696e206f6e6c79604482015260640161089c565b6001600160a01b038716610f905760405162461bcd60e51b815260206004820152602e60248201527f4e6f756e7344414f3a3a696e697469616c697a653a20696e76616c696420746960448201527f6d656c6f636b2061646472657373000000000000000000000000000000000000606482015260840161089c565b6001600160a01b03861661100c5760405162461bcd60e51b815260206004820152602b60248201527f4e6f756e7344414f3a3a696e697469616c697a653a20696e76616c6964206e6f60448201527f756e732061646472657373000000000000000000000000000000000000000000606482015260840161089c565b6116808410158015611021575062013b008411155b6110935760405162461bcd60e51b815260206004820152602b60248201527f4e6f756e7344414f3a3a696e697469616c697a653a20696e76616c696420766f60448201527f74696e6720706572696f64000000000000000000000000000000000000000000606482015260840161089c565b600183101580156110a65750619d808311155b6111185760405162461bcd60e51b815260206004820152602a60248201527f4e6f756e7344414f3a3a696e697469616c697a653a20696e76616c696420766f60448201527f74696e672064656c617900000000000000000000000000000000000000000000606482015260840161089c565b6001821015801561112b57506103e88211155b61119d5760405162461bcd60e51b815260206004820152603060248201527f4e6f756e7344414f3a3a696e697469616c697a653a20696e76616c696420707260448201527f6f706f73616c207468726573686f6c6400000000000000000000000000000000606482015260840161089c565b60c881101580156111b057506107d08111155b6112225760405162461bcd60e51b815260206004820152603060248201527f4e6f756e7344414f3a3a696e697469616c697a653a20696e76616c696420707260448201527f6f706f73616c207468726573686f6c6400000000000000000000000000000000606482015260840161089c565b60055460408051918252602082018690527f7e3f7f0708a84de9203036abaa450dccc85ad5ff52f78c170f3edb55cf5e8828910160405180910390a160045460408051918252602082018590527fc565b045403dc03c2eea82b81a0465edad9e2e7fc4d97e11421c209da93d7a93910160405180910390a160065460408051918252602082018490527ffc216faa269bf440fb06aa490693f409461bde9cdcb949c7b9f2cb79589e7a58910160405180910390a160075460408051918252602082018390527fd73ab1b53ca7a080713bcecd1a0acb2066a6a6c3d2fd6d78b67ae5005e652d9b910160405180910390a1600980547fffffffffffffffffffffffff00000000000000000000000000000000000000009081166001600160a01b03998a1617909155600a8054821697891697909717909655600380549096169490961693909317909355600555600491909155600655600755565b6060806060806000600b6000878152602001908152602001600020905080600501816006018260070183600801838054806020026020016040519081016040528092919081815260200182805480156113fe57602002820191906000526020600020905b81546001600160a01b031681526001909101906020018083116113e0575b505050505093508280548060200260200160405190810160405280929190818152602001828054801561145057602002820191906000526020600020905b81548152602001906001019080831161143c575b5050505050925081805480602002602001604051908101604052809291908181526020016000905b8282101561152457838290600052602060002001805461149790614120565b80601f01602080910402602001604051908101604052809291908181526020018280546114c390614120565b80156115105780601f106114e557610100808354040283529160200191611510565b820191906000526020600020905b8154815290600101906020018083116114f357829003601f168201915b505050505081526020019060010190611478565b50505050915080805480602002602001604051908101604052809291908181526020016000905b828210156115f757838290600052602060002001805461156a90614120565b80601f016020809104026020016040519081016040528092919081815260200182805461159690614120565b80156115e35780601f106115b8576101008083540402835291602001916115e3565b820191906000526020600020905b8154815290600101906020018083116115c657829003601f168201915b50505050508152602001906001019061154b565b5050505090509450945094509450509193509193565b604080518082018252600981527f4e6f756e732044414f000000000000000000000000000000000000000000000060209182015281517f8cad95687ba82c2ce50e74f7b754645e5117c3a5bec8151c0726d5857980a866818301527fe1dd93b3612547b4bb7c3d429f3df8508d84f5a4f63b5e2e44340b94698e6b3b81840152466060820152306080808301919091528351808303909101815260a0820184528051908301207f150214d74d59b7d1e90c73fc22ef3d991dd0a76b046543d4d80ab92d2a50328f60c083015260e0820189905260ff881661010080840191909152845180840390910181526101208301909452835193909201929092207f19010000000000000000000000000000000000000000000000000000000000006101408401526101428301829052610162830181905290916000906101820160408051601f198184030181528282528051602091820120600080855291840180845281905260ff8a169284019290925260608301889052608083018790529092509060019060a0016020604051602081039080840390855afa1580156117b5573d6000803e3d6000fd5b5050604051601f1901519150506001600160a01b03811661183e5760405162461bcd60e51b815260206004820152602a60248201527f4e6f756e7344414f3a3a63617374566f746542795369673a20696e76616c696460448201527f207369676e617475726500000000000000000000000000000000000000000000606482015260840161089c565b806001600160a01b03167fb8e138887d0aa13bab447e82de9d5c1777041ecd21ca36ba824ff1e6c07ddda48a8a611876858e8e613220565b6040805193845260ff90921660208401526bffffffffffffffffffffffff169082015260806060820181905260009082015260a00160405180910390a2505050505050505050565b60008160085410156119375760405162461bcd60e51b8152602060048201526024808201527f4e6f756e7344414f3a3a73746174653a20696e76616c69642070726f706f736160448201527f6c20696400000000000000000000000000000000000000000000000000000000606482015260840161089c565b6000828152600b60205260409020600e810154610100900460ff16156119605750600892915050565b600e81015460ff16156119765750600292915050565b8060090154431161198a5750600092915050565b80600a0154431161199e5750600192915050565b80600c015481600b01541115806119bc5750806003015481600b0154105b156119ca5750600392915050565b80600401546000036119df5750600492915050565b600e81015462010000900460ff16156119fb5750600792915050565b600960009054906101000a90046001600160a01b03166001600160a01b031663c1a287e26040518163ffffffff1660e01b8152600401602060405180830381865afa158015611a4e573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611a7291906142ea565b8160040154611a819190614303565b4210611a905750600692915050565b50600592915050565b50919050565b6007611aaa826118be565b6008811115611abb57611abb613bf2565b03611b2e5760405162461bcd60e51b815260206004820152603160248201527f4e6f756e7344414f3a3a63616e63656c3a2063616e6e6f742063616e63656c2060448201527f65786563757465642070726f706f73616c000000000000000000000000000000606482015260840161089c565b6000818152600b6020526040902060018101546001600160a01b0316331480611c1457506002810154600a546001808401546001600160a01b039283169263782d6fe192911690611b7f904361431b565b6040517fffffffff0000000000000000000000000000000000000000000000000000000060e085901b1681526001600160a01b0390921660048301526024820152604401602060405180830381865afa158015611be0573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611c0491906142bc565b6bffffffffffffffffffffffff16105b611c865760405162461bcd60e51b815260206004820152602a60248201527f4e6f756e7344414f3a3a63616e63656c3a2070726f706f7365722061626f766560448201527f207468726573686f6c6400000000000000000000000000000000000000000000606482015260840161089c565b600e810180547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff0016600117905560005b6005820154811015611dcf576009546005830180546001600160a01b039092169163591fcdfe919084908110611cee57611cee6140f1565b6000918252602090912001546006850180546001600160a01b039092169185908110611d1c57611d1c6140f1565b9060005260206000200154856007018581548110611d3c57611d3c6140f1565b90600052602060002001866008018681548110611d5b57611d5b6140f1565b9060005260206000200187600401546040518663ffffffff1660e01b8152600401611d8a959493929190614208565b600060405180830381600087803b158015611da457600080fd5b505af1158015611db8573d6000803e3d6000fd5b505050508080611dc790614284565b915050611cb6565b506040518281527f789cf55be980739dad1d0699b93b58e806b51c9d96619bfa8fe0a28abaa7b30c90602001610966565b337fb8e138887d0aa13bab447e82de9d5c1777041ecd21ca36ba824ff1e6c07ddda48383611e2f848383613220565b6040805193845260ff90921660208401526bffffffffffffffffffffffff169082015260806060820181905260009082015260a00160405180910390a25050565b6000546001600160a01b03163314611ef05760405162461bcd60e51b815260206004820152602860248201527f4e6f756e7344414f3a3a5f73657451756f72756d566f7465734250533a20616460448201527f6d696e206f6e6c79000000000000000000000000000000000000000000000000606482015260840161089c565b60c88110158015611f0357506107d08111155b611f755760405162461bcd60e51b815260206004820152603b60248201527f4e6f756e7344414f3a3a5f73657450726f706f73616c5468726573686f6c643a60448201527f20696e76616c69642070726f706f73616c207468726573686f6c640000000000606482015260840161089c565b600780549082905560408051828152602081018490527fd73ab1b53ca7a080713bcecd1a0acb2066a6a6c3d2fd6d78b67ae5005e652d9b9101610966565b337fb8e138887d0aa13bab447e82de9d5c1777041ecd21ca36ba824ff1e6c07ddda48585611fe2848383613220565b8686604051611ff5959493929190614332565b60405180910390a250505050565b6003546001600160a01b031633146120835760405162461bcd60e51b815260206004820152602160248201527f4e6f756e7344414f3a3a5f7365745665746f65723a207665746f6572206f6e6c60448201527f7900000000000000000000000000000000000000000000000000000000000000606482015260840161089c565b600354604080516001600160a01b03928316815291831660208301527fc5644f3588a066b15dcf6b636b74aadca57cfaccf608d9de7d8786364b7a8d02910160405180910390a1600380547fffffffffffffffffffffffff0000000000000000000000000000000000000000166001600160a01b0392909216919091179055565b6000546001600160a01b031633146121845760405162461bcd60e51b815260206004820152602e60248201527f4e6f756e7344414f3a3a5f73657450726f706f73616c5468726573686f6c644260448201527f50533a2061646d696e206f6e6c79000000000000000000000000000000000000606482015260840161089c565b6001811015801561219757506103e88111155b6122095760405162461bcd60e51b815260206004820152603b60248201527f4e6f756e7344414f3a3a5f73657450726f706f73616c5468726573686f6c643a60448201527f20696e76616c69642070726f706f73616c207468726573686f6c640000000000606482015260840161089c565b600680549082905560408051828152602081018490527ffc216faa269bf440fb06aa490693f409461bde9cdcb949c7b9f2cb79589e7a589101610966565b6000610e36600654600a60009054906101000a90046001600160a01b03166001600160a01b03166318160ddd6040518163ffffffff1660e01b8152600401602060405180830381865afa158015610dff573d6000803e3d6000fd5b6000546001600160a01b031633146123225760405162461bcd60e51b815260206004820152602660248201527f4e6f756e7344414f3a3a5f73657450656e64696e6741646d696e3a2061646d6960448201527f6e206f6e6c790000000000000000000000000000000000000000000000000000606482015260840161089c565b600180546001600160a01b038381167fffffffffffffffffffffffff000000000000000000000000000000000000000083168117909355604080519190921680825260208201939093527fca4f2f25d0898edd99413412fb94012f9e54ec8142f9b093e7720646a95b16a99101610966565b6003546001600160a01b031633146124145760405162461bcd60e51b815260206004820152602560248201527f4e6f756e7344414f3a3a5f6275726e5665746f506f7765723a207665746f657260448201527f206f6e6c79000000000000000000000000000000000000000000000000000000606482015260840161089c565b61241e6000612003565b565b60006124546040518060a0016040528060008152602001600081526020016000815260200160008152602001600081525090565b600a60009054906101000a90046001600160a01b03166001600160a01b03166318160ddd6040518163ffffffff1660e01b8152600401602060405180830381865afa1580156124a7573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906124cb91906142bc565b6bffffffffffffffffffffffff168082526006546124e891613200565b60208201819052600a546001600160a01b031663782d6fe13361250c60014361431b565b6040517fffffffff0000000000000000000000000000000000000000000000000000000060e085901b1681526001600160a01b0390921660048301526024820152604401602060405180830381865afa15801561256d573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061259191906142bc565b6bffffffffffffffffffffffff16116126125760405162461bcd60e51b815260206004820152603a60248201527f4e6f756e7344414f3a3a70726f706f73653a2070726f706f73657220766f746560448201527f732062656c6f772070726f706f73616c207468726573686f6c64000000000000606482015260840161089c565b85518751148015612624575084518751145b8015612631575083518751145b6126a35760405162461bcd60e51b815260206004820152603f60248201527f4e6f756e7344414f3a3a70726f706f73653a2070726f706f73616c2066756e6360448201527f74696f6e20696e666f726d6174696f6e206172697479206d69736d6174636800606482015260840161089c565b865160000361271a5760405162461bcd60e51b815260206004820152602760248201527f4e6f756e7344414f3a3a70726f706f73653a206d7573742070726f766964652060448201527f616374696f6e7300000000000000000000000000000000000000000000000000606482015260840161089c565b600a875111156127925760405162461bcd60e51b815260206004820152602360248201527f4e6f756e7344414f3a3a70726f706f73653a20746f6f206d616e79206163746960448201527f6f6e730000000000000000000000000000000000000000000000000000000000606482015260840161089c565b336000908152600c602052604090819020549082018190521561291c5760006127be82604001516118be565b905060018160088111156127d4576127d4613bf2565b0361286d5760405162461bcd60e51b815260206004820152605360248201527f4e6f756e7344414f3a3a70726f706f73653a206f6e65206c6976652070726f7060448201527f6f73616c207065722070726f706f7365722c20666f756e6420616e20616c726560648201527f616479206163746976652070726f706f73616c00000000000000000000000000608482015260a40161089c565b600081600881111561288157612881613bf2565b0361291a5760405162461bcd60e51b815260206004820152605460248201527f4e6f756e7344414f3a3a70726f706f73653a206f6e65206c6976652070726f7060448201527f6f73616c207065722070726f706f7365722c20666f756e6420616e20616c726560648201527f6164792070656e64696e672070726f706f73616c000000000000000000000000608482015260a40161089c565b505b6004546129299043614303565b6060820181905260055461293c91614303565b60808201526008805490600061295183614284565b90915550506008546000818152600b602090815260409091209182556001820180547fffffffffffffffffffffffff00000000000000000000000000000000000000001633179055820151600282015560075482516129b09190613200565b60038201556000600482015587516129d190600583019060208b0190613763565b5086516129e790600683019060208a01906137e0565b5085516129fd906007830190602089019061381b565b508451612a13906008830190602088019061386d565b506060820151600982019081556080830151600a83019081556000600b8401819055600c808501829055600d8501829055600e850180547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffff000000169055845460018601546001600160a01b031683526020919091526040918290208190559254915490517f7d84a6263ae0d98d3329bd7b46bb4e8d6f98cd35a7adb45c274c8b7fd5ebd5e093612ad093909233928e928e928e928e9291908e90614387565b60405180910390a17f6af0134faa0f9290c1d686d55012aca80302d31d5c856e4bc7954f7613dc7f878160000154338a8a8a8a876009015488600a015489600201548a600301548e604051612b2f9b9a9998979695949392919061441d565b60405180910390a154979650505050505050565b6004612b4e826118be565b6008811115612b5f57612b5f613bf2565b14612bd25760405162461bcd60e51b815260206004820152603f60248201527f4e6f756e7344414f3a3a71756575653a2070726f706f73616c2063616e206f6e60448201527f6c79206265207175657565642069662069742069732073756363656564656400606482015260840161089c565b6000818152600b6020908152604080832060095482517f6a42b8f800000000000000000000000000000000000000000000000000000000815292519194936001600160a01b0390911692636a42b8f892600480830193928290030181865afa158015612c42573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190612c6691906142ea565b612c709042614303565b905060005b6005830154811015612e3a57612e28836005018281548110612c9957612c996140f1565b6000918252602090912001546006850180546001600160a01b039092169184908110612cc757612cc76140f1565b9060005260206000200154856007018481548110612ce757612ce76140f1565b906000526020600020018054612cfc90614120565b80601f0160208091040260200160405190810160405280929190818152602001828054612d2890614120565b8015612d755780601f10612d4a57610100808354040283529160200191612d75565b820191906000526020600020905b815481529060010190602001808311612d5857829003601f168201915b5050505050866008018581548110612d8f57612d8f6140f1565b906000526020600020018054612da490614120565b80601f0160208091040260200160405190810160405280929190818152602001828054612dd090614120565b8015612e1d5780601f10612df257610100808354040283529160200191612e1d565b820191906000526020600020905b815481529060010190602001808311612e0057829003601f168201915b50505050508661358b565b80612e3281614284565b915050612c75565b506004820181905560408051848152602081018390527f9a2e42fd6722813d69113e7d0079d3d940171428df7373df9c7f7617cfda2892910160405180910390a1505050565b6001546001600160a01b031633148015612e9957503315155b612f0b5760405162461bcd60e51b815260206004820152602a60248201527f4e6f756e7344414f3a3a5f61636365707441646d696e3a2070656e64696e672060448201527f61646d696e206f6e6c7900000000000000000000000000000000000000000000606482015260840161089c565b60008054600180546001600160a01b038082167fffffffffffffffffffffffff000000000000000000000000000000000000000080861682179096559490911690915560408051919092168082526020820184905292917ff9ffabca9c8276e99321725bcb43fb076a6c66a54b7f21c4e8146d8519b417dc910160405180910390a1600154604080516001600160a01b03808516825290921660208301527fca4f2f25d0898edd99413412fb94012f9e54ec8142f9b093e7720646a95b16a99101610966565b6005612fdc826118be565b6008811115612fed57612fed613bf2565b14613062576040805162461bcd60e51b81526020600482015260248101919091527f4e6f756e7344414f3a3a657865637574653a2070726f706f73616c2063616e2060448201527f6f6e6c7920626520657865637574656420696620697420697320717565756564606482015260840161089c565b6000818152600b60205260408120600e810180547fffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00ffff1662010000179055905b60058201548110156131cf576009546005830180546001600160a01b0390921691630825f38f9190849081106130d9576130d96140f1565b6000918252602090912001546006850180546001600160a01b039092169185908110613107576131076140f1565b9060005260206000200154856007018581548110613127576131276140f1565b90600052602060002001866008018681548110613146576131466140f1565b9060005260206000200187600401546040518663ffffffff1660e01b8152600401613175959493929190614208565b6000604051808303816000875af1158015613194573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526131bc91908101906144c3565b50806131c781614284565b9150506130a1565b506040518281527f712ae1383f79ac853f8d882153778e0260ef8f03b504e2866e0593e04d2b291f90602001610966565b600061271061320f848461453a565b6132199190614577565b9392505050565b6000600161322d846118be565b600881111561323e5761323e613bf2565b146132b15760405162461bcd60e51b815260206004820152602c60248201527f4e6f756e7344414f3a3a63617374566f7465496e7465726e616c3a20766f746960448201527f6e6720697320636c6f7365640000000000000000000000000000000000000000606482015260840161089c565b60028260ff16111561332b5760405162461bcd60e51b815260206004820152602d60248201527f4e6f756e7344414f3a3a63617374566f7465496e7465726e616c3a20696e766160448201527f6c696420766f7465207479706500000000000000000000000000000000000000606482015260840161089c565b6000838152600b602090815260408083206001600160a01b0388168452600f8101909252909120805460ff16156133ca5760405162461bcd60e51b815260206004820152602f60248201527f4e6f756e7344414f3a3a63617374566f7465496e7465726e616c3a20766f746560448201527f7220616c726561647920766f7465640000000000000000000000000000000000606482015260840161089c565b600a5460045460098401546000926001600160a01b03169163782d6fe1918a916133f39161431b565b6040517fffffffff0000000000000000000000000000000000000000000000000000000060e085901b1681526001600160a01b0390921660048301526024820152604401602060405180830381865afa158015613454573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061347891906142bc565b90508460ff166000036134ad57806bffffffffffffffffffffffff1683600c01546134a39190614303565b600c84015561350f565b8460ff166001036134e057806bffffffffffffffffffffffff1683600b01546134d69190614303565b600b84015561350f565b8460ff1660020361350f57806bffffffffffffffffffffffff1683600d01546135099190614303565b600d8401555b81546bffffffffffffffffffffffff821662010000027fffffffffffffffffffffffffffffffffffff000000000000000000000000ffff60ff8816610100027fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff00009093169290921760011791909116179091559150509392505050565b6009546040516001600160a01b039091169063f2b06537906135b990889088908890889088906020016145b2565b604051602081830303815290604052805190602001206040518263ffffffff1660e01b81526004016135ed91815260200190565b602060405180830381865afa15801561360a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061362e91906145ec565b156136c75760405162461bcd60e51b815260206004820152605060248201527f4e6f756e7344414f3a3a71756575654f72526576657274496e7465726e616c3a60448201527f206964656e746963616c2070726f706f73616c20616374696f6e20616c72656160648201527f6479207175657565642061742065746100000000000000000000000000000000608482015260a40161089c565b6009546040517f3a66f9010000000000000000000000000000000000000000000000000000000081526001600160a01b0390911690633a66f9019061371890889088908890889088906004016145b2565b6020604051808303816000875af1158015613737573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061375b91906142ea565b505050505050565b8280548282559060005260206000209081019282156137d0579160200282015b828111156137d057825182547fffffffffffffffffffffffff0000000000000000000000000000000000000000166001600160a01b03909116178255602090920191600190910190613783565b506137dc9291506138bf565b5090565b8280548282559060005260206000209081019282156137d0579160200282015b828111156137d0578251825591602001919060010190613800565b828054828255906000526020600020908101928215613861579160200282015b8281111561386157825182906138519082614659565b509160200191906001019061383b565b506137dc9291506138d4565b8280548282559060005260206000209081019282156138b3579160200282015b828111156138b357825182906138a39082614659565b509160200191906001019061388d565b506137dc9291506138f1565b5b808211156137dc57600081556001016138c0565b808211156137dc5760006138e8828261390e565b506001016138d4565b808211156137dc576000613905828261390e565b506001016138f1565b50805461391a90614120565b6000825580601f1061392a575050565b601f01602090049060005260206000209081019061394891906138bf565b50565b60006020828403121561395d57600080fd5b5035919050565b60005b8381101561397f578181015183820152602001613967565b8381111561398e576000848401525b50505050565b600081518084526139ac816020860160208601613964565b601f01601f19169290920160200192915050565b6020815260006132196020830184613994565b80356001600160a01b03811681146139ea57600080fd5b919050565b600060208284031215613a0157600080fd5b613219826139d3565b600080600080600080600060e0888a031215613a2557600080fd5b613a2e886139d3565b9650613a3c602089016139d3565b9550613a4a604089016139d3565b969995985095966060810135965060808101359560a0820135955060c0909101359350915050565b600081518084526020808501945080840160005b83811015613aab5781516001600160a01b031687529582019590820190600101613a86565b509495945050505050565b600081518084526020808501945080840160005b83811015613aab57815187529582019590820190600101613aca565b600081518084526020808501808196508360051b8101915082860160005b85811015613b2e578284038952613b1c848351613994565b98850198935090840190600101613b04565b5091979650505050505050565b608081526000613b4e6080830187613a72565b8281036020840152613b608187613ab6565b90508281036040840152613b748186613ae6565b90508281036060840152613b888185613ae6565b979650505050505050565b803560ff811681146139ea57600080fd5b600080600080600060a08688031215613bbc57600080fd5b85359450613bcc60208701613b93565b9350613bda60408701613b93565b94979396509394606081013594506080013592915050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fd5b6020810160098310613c5c577f4e487b7100000000000000000000000000000000000000000000000000000000600052602160045260246000fd5b91905290565b60008060408385031215613c7557600080fd5b82359150613c8560208401613b93565b90509250929050565b60008060008060608587031215613ca457600080fd5b84359350613cb460208601613b93565b9250604085013567ffffffffffffffff80821115613cd157600080fd5b818701915087601f830112613ce557600080fd5b813581811115613cf457600080fd5b886020828501011115613d0657600080fd5b95989497505060200194505050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052604160045260246000fd5b604051601f8201601f1916810167ffffffffffffffff81118282101715613d6d57613d6d613d15565b604052919050565b600067ffffffffffffffff821115613d8f57613d8f613d15565b5060051b60200190565b600082601f830112613daa57600080fd5b81356020613dbf613dba83613d75565b613d44565b82815260059290921b84018101918181019086841115613dde57600080fd5b8286015b84811015613e0057613df3816139d3565b8352918301918301613de2565b509695505050505050565b600082601f830112613e1c57600080fd5b81356020613e2c613dba83613d75565b82815260059290921b84018101918181019086841115613e4b57600080fd5b8286015b84811015613e005780358352918301918301613e4f565b600067ffffffffffffffff821115613e8057613e80613d15565b50601f01601f191660200190565b6000613e9c613dba84613e66565b9050828152838383011115613eb057600080fd5b828260208301376000602084830101529392505050565b600082601f830112613ed857600080fd5b61321983833560208501613e8e565b600082601f830112613ef857600080fd5b81356020613f08613dba83613d75565b82815260059290921b84018101918181019086841115613f2757600080fd5b8286015b84811015613e0057803567ffffffffffffffff811115613f4b5760008081fd5b613f598986838b0101613ec7565b845250918301918301613f2b565b600082601f830112613f7857600080fd5b81356020613f88613dba83613d75565b82815260059290921b84018101918181019086841115613fa757600080fd5b8286015b84811015613e0057803567ffffffffffffffff811115613fcb5760008081fd5b8701603f81018913613fdd5760008081fd5b613fee898683013560408401613e8e565b845250918301918301613fab565b600080600080600060a0868803121561401457600080fd5b853567ffffffffffffffff8082111561402c57600080fd5b61403889838a01613d99565b9650602088013591508082111561404e57600080fd5b61405a89838a01613e0b565b9550604088013591508082111561407057600080fd5b61407c89838a01613ee7565b9450606088013591508082111561409257600080fd5b61409e89838a01613f67565b935060808801359150808211156140b457600080fd5b506140c188828901613ec7565b9150509295509295909350565b600080604083850312156140e157600080fd5b82359150613c85602084016139d3565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052603260045260246000fd5b600181811c9082168061413457607f821691505b602082108103611a99577f4e487b7100000000000000000000000000000000000000000000000000000000600052602260045260246000fd5b6000815461417a81614120565b80855260206001838116801561419757600181146141cf576141fd565b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff008516838901528284151560051b89010195506141fd565b866000528260002060005b858110156141f55781548a82018601529083019084016141da565b890184019650505b505050505092915050565b6001600160a01b038616815284602082015260a06040820152600061423060a083018661416d565b8281036060840152614242818661416d565b9150508260808301529695505050505050565b7f4e487b7100000000000000000000000000000000000000000000000000000000600052601160045260246000fd5b60007fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff82036142b5576142b5614255565b5060010190565b6000602082840312156142ce57600080fd5b81516bffffffffffffffffffffffff8116811461321957600080fd5b6000602082840312156142fc57600080fd5b5051919050565b6000821982111561431657614316614255565b500190565b60008282101561432d5761432d614255565b500390565b85815260ff851660208201526bffffffffffffffffffffffff8416604082015260806060820152816080820152818360a0830137600081830160a090810191909152601f909201601f19160101949350505050565b60006101208b83526001600160a01b038b1660208401528060408401526143b08184018b613a72565b905082810360608401526143c4818a613ab6565b905082810360808401526143d88189613ae6565b905082810360a08401526143ec8188613ae6565b90508560c08401528460e084015282810361010084015261440d8185613994565b9c9b505050505050505050505050565b60006101608d83526001600160a01b038d1660208401528060408401526144468184018d613a72565b9050828103606084015261445a818c613ab6565b9050828103608084015261446e818b613ae6565b905082810360a0840152614482818a613ae6565b90508760c08401528660e084015285610100840152846101208401528281036101408401526144b18185613994565b9e9d5050505050505050505050505050565b6000602082840312156144d557600080fd5b815167ffffffffffffffff8111156144ec57600080fd5b8201601f810184136144fd57600080fd5b805161450b613dba82613e66565b81815285602083850101111561452057600080fd5b614531826020830160208601613964565b95945050505050565b6000817fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff048311821515161561457257614572614255565b500290565b6000826145ad577f4e487b7100000000000000000000000000000000000000000000000000000000600052601260045260246000fd5b500490565b6001600160a01b038616815284602082015260a0604082015260006145da60a0830186613994565b82810360608401526142428186613994565b6000602082840312156145fe57600080fd5b8151801515811461321957600080fd5b601f82111561465457600081815260208120601f850160051c810160208610156146355750805b601f850160051c820191505b8181101561375b57828155600101614641565b505050565b815167ffffffffffffffff81111561467357614673613d15565b614687816146818454614120565b8461460e565b602080601f8311600181146146da57600084156146a45750858301515b7fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff600386901b1c1916600185901b17855561375b565b600085815260208120601f198616915b82811015614709578886015182559484019460019091019084016146ea565b508582101561474557878501517fffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff600388901b60f8161c191681555b5050505050600190811b0190555056fea26469706673582212208c7b92e41193d878439db5fc411cbdd1df02d86f3d5b13a3468b65d865d38a0064736f6c634300080f0033";
const isSuperArgs = (xs) => xs.length > 1;
class NounsDAOLogicV1__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.NounsDAOLogicV1__factory = NounsDAOLogicV1__factory;
NounsDAOLogicV1__factory.bytecode = _bytecode;
NounsDAOLogicV1__factory.abi = _abi;
